import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ChangePasswordPage } from '../features/auth/components/ChangePasswordPage';

const accountActivationSearchSchema = z.object({
  axprtl: z.string().optional(),
});

export const Route = createFileRoute('/account-activation')({
  validateSearch: accountActivationSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search.axprtl) {
      throw redirect({ to: '/login' });
    }
  },
  component: AccountActivationPage,
});

function AccountActivationPage() {
  const { axprtl } = Route.useSearch();
  return <ChangePasswordPage axprtl={axprtl} />;
}
